<template>
  <div>
    <vue-headful title="Credimóvil | Preaprobación" :head="{
      'meta[charset]': { charset: 'utf-8' },
    }" />
    <menu-solicitud v-bind:use-apply-now="false"></menu-solicitud>

    <!-- Banner Area -->
    <section class="banner_area banner_area_7">
      <div class="container"
        v-bind:class="{ show: (currentStep < 5 && currentStep != -1), hide: (currentStep >= 5 || currentStep == -1) }">
        <h6>Ingresa algunos datos y en segundos sabrás si tu financiamiento ha sido preautorizado</h6>
        <h2>Preaprobación</h2>
        <ol class="breadcrumb">
          <li></li>
          <li></li>
        </ol>
      </div>
    </section>
    <!-- Banner Area -->
    <!-- Easy cash Area -->
    <section class="easy_cash_area cot-credict getting_loan_area gla_2 ">
      <div id="bannerlateral" class="container">
        <div class="row">
          <div class="getting_loan_area gla_2 col-lg-5 back-form paso0"
            v-bind:class="{ show: (currentStep < 5 && currentStep != -1), hide: (currentStep >= 5 || currentStep == -1) }">
            <div class="row getting_inner">
              <div class="col-lg-10 getting_first">
                <div class="tittle la">
                  <h2>Completa tú aprobación <span>en unos cuantos pasos</span></h2>
                </div>
                <div class="getting_items gi_f wow fadeInUp">
                  <span><img src="images/icons/1.png" alt="Solicitud"></span>
                  <h3>Paso 1</h3>
                  <p>Información personal</p>
                </div>
                <div class="getting_items icon-paso-2 wow fadeInUp" data-wow-delay="0.3s"
                  v-bind:class="{ gi_f: (currentStep >= 2) }">
                  <span><img src="images/icons/2.png" alt="Pre-aprobación"></span>
                  <h3>Paso 2</h3>
                  <p>Dirección</p>
                </div>
                <div class="getting_items icon-paso-3 wow fadeInUp" data-wow-delay="0.6s"
                  v-bind:class="{ gi_f: (currentStep >= 3) }">
                  <span><img src="images/icons/3.png" alt="Beneficios"></span>
                  <h3>Paso 3</h3>
                  <p>Sociedad de información crediticia</p>
                </div>
                <div class="getting_items icon-paso-4 wow fadeInUp" data-wow-delay="0.6s"
                  v-bind:class="{ gi_f: (currentStep >= 4) }">
                  <span><img src="images/icons/4.png" alt="Beneficios"></span>
                  <h3>Paso 4</h3>
                  <p>Autorización</p>
                </div>
              </div>
            </div>
          </div>
          <!-- Potential Area -->
          <section class="col-12 potential_area poa_2 bene_credict back-form paso5"
            v-bind:class="{ show: (currentStep == 5), hide: (currentStep != 5) }">
            <div class="container">
              <div class="tittle p-4">
                <h2>¡Felicidades, estas preaprobado!</h2>
                <h3 class="pt-2">{{ this.detailsData.data.first_name + " " + this.detailsData.data.father_name }}</h3>
                <p>Para continuar con el trámite de tu crédito requerimos información adicional.</p>
                <div class="form-group col-12 d-flex flex-wrap justify-content-center p-1 m-0">
                  <div class="form-group col-6 d-flex flex-wrap justify-content-center">
                    <button id="btn-help" class="btn btn-lg bg-success text-white" v-on:click="formGrayZone()">
                      Continuar</button>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-wrap justify-content-center  p-0 m-0">
                <img src="images/icons/celebrando.png" alt="">
              </div>

            </div>
          </section>
          <div class="col-12 potential_area poa_2 bene_credict back-form paso10"
            v-bind:class="{ show: (currentStep == 10), hide: (currentStep != 10) }">
            <div class="container ">
              <div class="offset-md-2 offset-sm-0 pb-2">
                <b class="tittleH2">Estatus de tu solicitud</b>
                <h5 class=""><b>NOMBRE:</b>
                  {{ this.detailsData.data.first_name + " " + this.detailsData.data.father_name }}
                </h5>
                <h5 class=""><b>Folio:</b>
                  CM{{ this.userData.data.id }}
                </h5>
              </div>
              <div class="d-flex flex-wrap justify-content-center">
                <v-tracking></v-tracking>
              </div>
            </div>
          </div>
          <div class="col-12 potential_area poa_2 bene_credict back-form paso7"
            v-bind:class="{ show: (currentStep == -1), hide: (currentStep != -1) }">
            <div class="container d-flex flex-wrap justify-content-center">
              <div class="tittle">
                <h2>Por favor intenta de nuevo en 6 meses</h2>
                <h3 class="pt-2">{{ this.detailsData.data.first_name + " " + this.detailsData.data.father_name }}</h3>
                <p>Lamentablemente no podemos seguir con tu proceso, Por favor intenta de nuevo en 6 meses.</p>
              </div>
              <div class="col-9">
                <img src="images/icons/pausa.webp" class="img-fluid" alt="">
              </div>
            </div>
          </div>
          <!-- Potential Area -->
          <div class="col-lg-7 back-form-2"
            v-bind:class="{ show: (currentStep < 5 && currentStep != -1), hide: (currentStep >= 5 || currentStep == -1) }">
            <form class="from_main" action="php/contact.php" method="post" id="phpcontactform" novalidate="novalidate">
              <div class="row">
                <div class="col-lg-12 paso1" v-bind:class="{ show: (currentStep == 1), hide: (currentStep != 1) }">
                  <div class="row">

                    <div class="col-lg-6 select_from">
                      <h6>Nombre*</h6>
                      <input type="text" class="post_select" id="name" name="name" v-model="detailsData.data.first_name"
                        :class="{ 'error': $v.detailsData.data.first_name.$dirty && $v.detailsData.data.first_name.$invalid }"
                        @blur=" $v.detailsData.data.first_name.$touch(); detailsData.data.first_name = $event.target.value.toUpperCase().trim()">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Segundo nombre</h6>
                      <input type="text" class="post_select" id="second-name" name="second-name"
                        v-model="detailsData.data.last_name"
                        @blur="detailsData.data.last_name = $event.target.value.toUpperCase().trim()">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Apellido paterno*</h6>
                      <input type="text" class="post_select" id="apellido" name="apellido"
                        v-model="detailsData.data.father_name"
                        :class="{ 'error': $v.detailsData.data.father_name.$dirty && $v.detailsData.data.father_name.$invalid }"
                        @blur=" $v.detailsData.data.father_name.$touch(); detailsData.data.father_name = $event.target.value.toUpperCase().trim()">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Apellido materno</h6>
                      <input type="text" class="post_select" id="apellido-m" name="apellido-m"
                        v-model="detailsData.data.mother_name"
                        @blur="detailsData.data.mother_name = $event.target.value.toUpperCase().trim()">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Fecha de nacimiento*</h6>
                      <div class="input-icons">
                        <input type="text" readonly class="post_select input-field" id="birth-date" name="birth-date"
                          style="cursor: pointer">
                        <i class="fa fa-angle-down icon" style="color: white" v-on:click=selectDate()></i>
                      </div>
                    </div>
                    <div class="col-lg-6 select_from" style="margin-bottom: 30px;">
                      <h6>Sexo*</h6>
                      <select class="post_select input-field" id="genero"
                        :class="{ 'error': $v.detailsData.data.gender.$invalid }">
                        <option value="FEMENINO">FEMENINO</option>
                        <option value="MASCULINO">MASCULINO</option>
                      </select>
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Estado*</h6>
                      <input id="state_dob" type="search" class="post_select input-field" placeholder="Estado"
                        list="state_dob_list" v-model="detailsData.data.state_dob" v-on:change="onChangeStateDob"
                        autocomplete="off" />
                      <datalist class="post_select" id="state_dob_list"
                        :class="{ 'error': $v.detailsData.data.state_dob.$invalid }">
                        <option value="">Estado</option>
                        <option v-for="state in statesOrigin">{{ state }}</option>
                      </datalist>
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>RFC*</h6>
                      <input type="text" class="post_select" id="rfc" name="rfc" v-model="detailsData.data.RFC"
                        :class="{ 'error': $v.detailsData.data.RFC.$dirty && $v.detailsData.data.RFC.$invalid }"
                        @blur="$v.detailsData.data.RFC.$touch(); detailsData.data.RFC = $event.target.value.toUpperCase().trim()">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>CURP</h6>
                      <input type="text" class="post_select" id="curp" name="curp" v-model="detailsData.data.CURP"
                        :class="{ 'error': $v.detailsData.data.CURP.$invalid }"
                        @blur="detailsData.data.CURP = $event.target.value.toUpperCase().trim()">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Celular*</h6>
                      <input type="tel" class="post_select" id="phone" name="phone" v-only-numbers
                        v-model="userData.data.phone" disabled>
                    </div>
                    <div class="form-group col-lg-12">
                      <button class="theme_btn btn btnGoStep2 float-right scroll-step" id="btn-step-one"
                        :disabled="$v.detailsData.data.$invalid" v-on:click="saveStepOne()">Siguiente</button>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 paso2" v-bind:class="{ show: (currentStep == 2), hide: (currentStep != 2) }">
                  <div class="row">
                    <div class="col-lg-6 select_from">
                      <h6>C.P.*</h6>
                      <input type="text" class="post_select" id="postal" name="postal" v-only-numbers
                        v-model="addressData.data.postcode" v-on:change="onChangeCp"
                        @blur=" $v.addressData.data.postcode.$touch()"
                        :class="{ 'error': $v.addressData.data.postcode.$dirty && $v.addressData.data.postcode.$invalid }">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Estado*</h6>
                      <input id="state" type="search" class="post_select input-field" placeholder="Estado"
                        list="state_list" v-model="addressData.data.state" v-on:change="onChangeState"
                        autocomplete="off" />
                      <datalist class="post_select" id="state_list"
                        :class="{ 'error': $v.addressData.data.state.$invalid }">
                        <option v-for="state in states">{{ state }}</option>
                      </datalist>
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Municipio*</h6>
                      <input id="township" type="search" class="post_select input-field" placeholder="Municipio"
                        list="town_list" v-model="addressData.data.town" v-on:change="onChangeTown"
                        autocomplete="off" />
                      <datalist class="post_select" id="town_list"
                        :class="{ 'error': $v.addressData.data.town.$invalid }">
                        <option v-for="township in townships">{{ township }}</option>
                      </datalist>
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Colonia*</h6>
                      <input id="colonia" type="search" class="post_select input-field" placeholder="Colonia"
                        list="suburb_list" v-model="addressData.data.suburb" v-on:change="onChangeSuburb"
                        autocomplete="off" />
                      <datalist class="post_select" id="suburb_list"
                        :class="{ 'error': $v.addressData.data.suburb.$invalid }">
                        <option v-for="suburb in suburbs">{{ suburb }}</option>
                      </datalist>
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Calle*</h6>
                      <input type="text" class="post_select" id="calle" name="calle" v-model="addressData.data.street"
                        @blur=" $v.addressData.data.street.$touch()"
                        :class="{ 'error': $v.addressData.data.street.$dirty && $v.addressData.data.street.$invalid }">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Número exterior*</h6>
                      <input type="text" class="post_select" id="num-exterior" name="num-exterior" v-only-numbers
                        v-model="addressData.data.address_no" @blur=" $v.addressData.data.address_no.$touch()"
                        :class="{ 'error': $v.addressData.data.address_no.$dirty && $v.addressData.data.address_no.$invalid }">
                    </div>
                    <div class="col-lg-6 select_from">
                      <h6>Número interior</h6>
                      <input type="text" class="post_select" id="num-interior" name="num-interior"
                        v-model="addressData.data.address_inside_no">
                    </div>

                    <div class="col-lg-6 select_from">
                    </div>

                    <div class="form-group col-6">
                      <a class="btnBackStep1 theme_btn btn" id="js-contact-btn scroll-step"
                        v-on:click="currentStep = 1">Anterior</a>
                    </div>
                    <div class="form-group col-6">
                      <button class="btnGoStep3 theme_btn btn float-right scroll-step" id="btn-step-two"
                        :disabled="$v.addressData.data.$invalid" v-on:click="saveStepTwo()">Siguiente</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 paso3" v-bind:class="{ show: (currentStep == 3), hide: (currentStep != 3) }">
                <div class="row">
                  <div class="col-12 text-center title-preaprobacion">
                    <p>Ahora es necesario que consultemos tu historial crediticio</p>
                    <p>Comienza haciendo click en el botón para recibir tu código de autorización. Recíbelo en tu correo
                      registrado o en tu celular por medio de SMS.
                    </p>
                  </div>
                  <div class="col-lg-12 select_from">
                    <h6>¿Cómo quieres recibir tu código de autorización?</h6>
                    <select class="post_select" id="confirmation-type" required>
                      <option value="1">SMS</option>
                      <option value="2">Correo electrónico</option>
                      <option value="3">Ya cuento con un codígo</option>
                    </select>
                  </div>
                  <div class="form-group col-6">
                    <a class="btnBackStep2 theme_btn btn" id="js-contact-btn" v-on:click="currentStep = 2">Anterior</a>
                  </div>
                  <div class="form-group col-6">
                    <a class="btnGoStep4 theme_btn btn float-right scroll-step" id="btn-step-three"
                      v-on:click="saveStepThree()">Siguiente</a>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 paso4" v-bind:class="{ show: (currentStep == 4), hide: (currentStep != 4) }">
                <div class="row">
                  <div class="col-12 select_from">
                    <input checked type="checkbox" id="condicion-uno" name="condiciones" value="confirm_one"
                      v-model="confirmations" />
                    <span class="text-white" for="condiciones">
                      Al continuar acepto los <a href="/terms-conditions">Términos y condiciones</a> y la clausula de
                      medios electronicos tales como NIP
                    </span>
                  </div>
                  <div class="col-12 select_from ">
                    <input checked type="checkbox" id="condicion-dos" name="condiciones" value="confirm_two"
                      v-model="confirmations" />
                    <span class="text-white" for="condiciones">Confirmo que mi información es verídica y autorizo a GPI
                      AUTO COMERCIAL SAPI DE C.V. para la obtención de mi <a href="#" v-on:click="modalTyC">historial
                        crediticio.</a></span>
                  </div>
                  <div class="col-lg-12 select_from">
                    <h6>Confirmar código</h6>
                    <input type="text" class="post_select" id="confirmation-code" name="cof-codigo"
                      v-model="confirmationData.code" @blur="$v.confirmationData.code.$touch()"
                      :class="{ 'error': $v.confirmationData.code.$dirty && $v.confirmationData.code.$invalid }"
                      @input="confirmationData.code = $event.target.value.trim()">
                  </div>
                  <div class="col-lg-12 select_from">
                    <h6 class="col-12 text-white m-0 p-0">Clave del asesor</h6>
                    <small class="col-12 text-white m-0 p-0">(OPCIONAL) Solo completa este campo si recibiste ayuda de
                      un aseso.</small>
                    <input type="text" class="post_select" id="clave-asesor" name="clave-asesor"
                      v-model="userData.data.clave_asesor" @blur="$v.userData.data.clave_asesor.$touch()"
                      @input="userData.data.clave_asesor = $event.target.value.toUpperCase().trim()">
                  </div>
                  <div class="col-lg-12 select_from">
                    <h6 class="col-lg-12 text-white">Lote</h6>
                    <input type="search" class="post_select input-field" id="lote" list="post_select text-dark"
                      v-model="quote_credit.data.lote" v-on:change="onChangeLote" autocomplete="off"
                      @blur="$v.quote_credit.data.lote.$touch()"
                      :class="{ 'error': $v.quote_credit.data.lote.$dirty && $v.quote_credit.data.lote.$invalid }"
                      @input="quote_credit.data.lote = $event.target.value.trim()"

                    placeholder="Seleccione una opción..." required/>
                    <datalist id="post_select text-dark">
                      <option value="">Seleccione una opción...</option>
                      <option v-for="nombre in CatlogoLotes">{{ nombre }}</option>
                    </datalist>
                  </div>
                  <div class="form-group col-6">
                    <a class="btnBackStep3 theme_btn btn" id="js-contact-btn" v-on:click="currentStep = 3">Anterior</a>
                  </div>
                  <div class="form-group col-6">
                    <button class="btnGoStep5 theme_btn btn float-right scroll-step" id="btn-step-four"
                      :disabled="$v.confirmationData.code.$invalid || $v.quote_credit.data.lote.$invalid" v-on:click="saveStepFour()">Siguiente</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- End Easy cash Area -->

    <!-- Potential Area -->
    <section class="potential_area poa_2 vinculo-preaprobacion">
      <div class="container">
        <div class="tittle">
          <p>Todos tus datos serán guardados de forma segura y nuestro <a href="/privacy-notice">Aviso de Privacidad</a>
            garantiza que no serán compartidos con terceros.</p>
          <p>Recuerda que en Credimóvil estamos para ayudarte, si tienes alguna duda sobre el proceso puedes ponerte en
            contacto con nosotros en el teléfono <a href="tel:018002630474">01 800 263 0474</a> - <a
              href="tel:3310782829">33 1078 2829</a> o al correo <a
              href="mailto:contacto@gpicomercial.com.mx">contacto@gpicomercial.com.mx</a>
          </p>
        </div>
      </div>
    </section>
    <!-- Potential Area -->
    <div id="app" v-bind:class="{
      show: (currentStep == 5),
      hide: (currentStep != 5)
    }">
      <!-- <Particles id="tsparticles"
                  :particlesInit="particlesInit"
                  :particlesLoaded="particlesLoaded"
                  :options="opciones_view"/> -->
    </div>
  </div>


</template>

<script>
import moment from 'moment'
import statesAndTownship from '../assets/estados-municipios.json';
import statesOriginal from '../assets/estados-municipiosOriginal.json';
import statesKey from '../assets/clave-estados.json';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { loadFull } from "tsparticles";
import Tracking from "./Tracking/Tracking.vue";

var regexCurp = /^$|\s+|^NULL$|^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
var regexRfc = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
export default {
  name: 'PreApproval',
  components: {
    "v-tracking": Tracking
  },
  data() {
    return {
      CatlogoLotes: [],
      states: [],
      statesOrigin: [],
      townships: [],
      suburbs: [],
      birthDate: '',
      clickupTaskId: '',
      documentos: 0,
      detailsData: {
        data: {
          first_name: '',
          last_name: '',
          father_name: '',
          mother_name: '',
          DOB: '',
          state_dob: '',
          gender: 'MASCULINO',
          nacionality: 'MXN',
          RFC: '',
          CURP: '',
          marital_status: 'Soltero',
          antique: '2 o mas años',
          economic_dependents: ''
        }
      },
      employmentData: {
        data: {
          employment_situation: 'fixed',
          antique: '2 o mas años',
          net_income: '',
          default_ocupation: false,
        }
      },
      userData: {
        data: {
          id: '',
          name: '',
          email: '',
          phone: '',
          a_step: 0,
          clave_asesor: ''
        }
      },
      addressData: {
        data: {
          country: 'MX',
          street: '',
          address_no: '',
          address_inside_no: '',
          state: '',
          town: '',
          suburb: '',
          postcode: '',
          current_living: '',
          living_since: '',
          main_address: 1
        }
      },
      documents: {
        data: {
          clickupTaskId: '',
          ine: '',
          ingreso: '',
          domicilio: ''
        }
      },
      confirmationData: {
        code: ''
      },
      referenceData: {
        data: {
          name: '',
          phone: '',
          type: '',
        },
        data1: {
          name: '',
          phone: '',
          type: '',
        },
        data2: {
          name: '',
          phone: '',
          type: '',
        },
      },
      quote_credit: {
        data: {
          id: 0,
          user_id: "",
          lote: ""
        }
      },
      currentStep: 1,
      defaultOcupation: 'no',
      confirmations: ["confirm_one", "confirm_two"],
      opciones_view: {},
      opciones: {
        fullScreen: {
          zIndex: 1
        },
        particles: {
          color: {
            value: [
              '#F59019',
              '#2759AB',
              '#ffcb63',
              '#ffb4a9',
              '#49c9ff',
              '#49c9ff'
            ]
          },
          move: {
            direction: 'bottom',
            enable: true,
            outModes: {
              default: 'out'
            },
            size: true,
            speed: {
              min: 1,
              max: 5
            }
          },
          number: {
            value: 500,
            density: {
              enable: true,
              area: 800
            }
          },
          opacity: {
            value: .7,
            animation: {
              enable: false,
              startValue: 'max',
              destroy: 'min',
              speed: 0.5,
              sync: true
            }
          },
          rotate: {
            value: {
              min: 0,
              max: 360
            },
            direction: 'random',
            move: true,
            animation: {
              enable: true,
              speed: 60
            }
          },
          tilt: {
            direction: 'random',
            enable: true,
            move: true,
            value: {
              min: 0,
              max: 360
            },
            animation: {
              enable: true,
              speed: 60
            }
          },
          shape: {
            type: [
              'circle',
              'square'
            ],
            options: {}
          },
          size: {
            value: {
              min: 2,
              max: 4
            }
          },
          roll: {
            darken: {
              enable: true,
              value: 30
            },
            enlighten: {
              enable: true,
              value: 30
            },
            enable: true,
            speed: {
              min: 15,
              max: 25
            }
          },
          wobble: {
            distance: 20,
            enable: true,
            move: true,
            speed: {
              min: -15,
              max: 15
            }
          }
        },
        detectRetina: true
      },
    }
  },
  validations() {
    return {
      detailsData: {
        data: {
          first_name: { required },
          father_name: { required },
          gender: { required },
          state_dob: { required },
          RFC: { required, validateRfc: (value) => { return regexRfc.test(value) } },
          CURP: { validateCurp: (value) => { return regexCurp.test(value) } }
        }
      },
      addressData: {
        data: {
          street: { required },
          address_no: { required },
          state: { required },
          town: { required },
          suburb: { required },
          postcode: { required },
        }
      },
      confirmationData: {
        code: { required }
      },
      quote_credit: {
        data: { lote: { required } }
      },
      referenceData: {
        data: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        },
        data1: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        },
        data2: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        }
      },
    }
  },
  methods: {
    particlesInit(main) {
      loadFull(main);
    },
    particlesLoaded(container) {
      //console.log("Particles container loaded", container);
    },
    datalistValidator(modelname, modelList) {

      var result = (modelList.indexOf(modelname) > -1);
      if (!result) {
        this.$swal("Seleccione un elemento de la lista");
      }
      return result;
    },
    refreshSelects() {
      setTimeout(() => {
        $('#state').niceSelect('update');
        $('#state_dob').niceSelect('update');
        $('#township').niceSelect('update');
        $('#colonia').niceSelect('update');
        $('#postal').niceSelect('update');
        $('#birth-date, #atique-address-date').datepicker({
          dateFormat: 'dd-mm-yy',
          changeMonth: true,
          changeYear: true,
          yearRange: "-100:+0",
        });
      }, 100);
    },
    getStates() {
      this.states = Object.keys(statesAndTownship);
      this.statesOrigin = Object.keys(statesOriginal);
      this.refreshSelects();
    },
    getTownships() {
      if (this.addressData.data.state != "" && this.userData.data.a_step == 2) {
        this.townships = statesAndTownship[this.addressData.data.state];
        this.refreshSelects();
      }
    },
    getSuburb() {
      if (this.addressData.data.town != "" && this.userData.data.a_step == 2) {
        this.$CopomexService.getColoniaByMunicipio(this.addressData.data.town)
          .then((result) => {
            this.suburbs = Object.values(result.response.colonia);
            this.refreshSelects();
          });
      }
    },
    getCp() {
      if ($('#postal').val() == '') {
        this.$CopomexService.getCp(this.addressData.data.state, this.addressData.data.town, this.addressData.data.suburb)
          .then((result) => {
            this.addressData.data.postcode = result.response.cp[0];
            this.refreshSelects();
          });
      }
    },
    getLote() {
      this.$LoteService.getLote().then(
        result => {
          if (result.data.length > 0) {
            this.CatlogoLotes = result.data.map(item => item["nombre"]);
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    onChangeCp() {
      if ($('#postal').val() != '' && $('#postal').val().length >= 5) {
        this.preloader();
        this.$CopomexService.getInfoByEstado($('#postal').val()).then((result) => {

          this.suburbs = Object.values(result.response.asentamiento);
          $('#state').val(result.response.estado);
          this.addressData.data.state = result.response.estado;
          $('#township').val(result.response.municipio);
          this.addressData.data.town = result.response.municipio;
          $('#colonia').val('');
          this.addressData.data.suburb = '';
          this.preloaderHiden();
          this.refreshSelects();
        }).catch(function (err) {
          $('.preloader').fadeOut();
          $('.preloader').delay(10).fadeOut('slow');
        });
      }
    },
    getQuoteCredit() {
      this.$UserService.getCreditQuotation().then(
        result => {
          if (result.data.length > 0) {
            this.quote_credit.data.id = result.data[0].id;
            this.quote_credit.data.user_id = result.data[0].user_id;
            this.quote_credit.data.lote = result.data[0].lote;
          }
          setTimeout(() => {
            $("#lote").val(this.quote_credit.data.lote);
          }, 300);
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    onChangeState() {
      this.addressData.data.state = $('#state').val();
      if (this.datalistValidator(this.addressData.data.state, this.states)) {
        $('#postal').val('');
        this.addressData.data.postcode = '';
        $('#township').val('');
        this.addressData.data.town = '';
        $('#colonia').val('');
        this.addressData.data.suburb = '';
        this.getTownships();
      } else {
        $('#state').val('');
        this.detailsData.data.state = "";
        this.refreshSelects();
      }
    },
    onChangeTown() {
      this.addressData.data.town = $('#township').val();
      if (this.datalistValidator(this.addressData.data.town, this.townships)) {
        $('#postal').val('');
        this.addressData.data.postcode = '';
        $('#colonia').val('');
        this.addressData.data.suburb = '';
        this.getSuburb();
      } else {
        $('#township').val('');
        this.addressData.data.town = "";
        this.refreshSelects();
      }
    },
    onChangeSuburb() {
      this.addressData.data.suburb = $('#colonia').val();
      if (this.datalistValidator(this.addressData.data.suburb, this.suburbs)) {
        this.getCp();
      } else {
        $('#colonia').val('');
        this.addressData.data.suburb = "";
        this.refreshSelects();
      }
      this.refreshSelects();
    },
    onChangeStateDob() {
      this.detailsData.data.state_dob = $('#state_dob').val();
      if (this.datalistValidator(this.detailsData.data.state_dob, this.statesOrigin)) {

        var ap_paterno = this.detailsData.data.father_name;
        var ap_materno = this.detailsData.data.mother_name;
        var nombre = this.detailsData.data.first_name + " " + this.detailsData.data.last_name;
        var rfc = moment($('#birth-date').val(), 'DD-MM-YYYY').format('YYMMDD');
        this.detailsData.data.gender = $('#genero').val();
        var sexo = $('#genero').val() == "MASCULINO" ? "H" : "M";
        var estado = statesKey[this.detailsData.data.state_dob];
        setTimeout(() => {
          var result = this.$CURPyRFC.calculaRFCyCURP(ap_paterno, ap_materno, nombre, rfc, sexo, estado);
          this.detailsData.data.CURP = result.CURP;
          this.detailsData.data.RFC = result.RFC;
          this.refreshSelects();
        }, 100);
      } else {
        $('#state_dob').val('');
        this.detailsData.data.state_dob = "";
        this.refreshSelects();
      }
    },
    onChangeLote() {
      this.quote_credit.data.lote = $("#lote").val();
      if (this.quote_credit.data.lote != "" &&
        !this.datalistValidator(
          this.quote_credit.data.lote,
          this.CatlogoLotes
        )
      ) {
        $("#lote").val("");
        this.quote_credit.data.lote = "";
      }
    },
    saveStepOne() {
      this.preloader();
      this.userData.data.name = `${this.detailsData.data.first_name} ${this.detailsData.data.father_name}`;
      this.userData.data.a_step = 2;
      this.employmentData.data.default_ocupation = (this.defaultOcupation == 'yes' ? true : false);
      this.detailsData.data.DOB = moment($('#birth-date').val(), 'DD-MM-YYYY').format('YYYY-MM-DD');
      this.detailsData.data.gender = $('#genero').val();
      this.detailsData.data.nacionality = $('#nacionalidad').val();
      this.detailsData.data.marital_status = $('#estado-civil').val();
      this.detailsData.data.antique = $('#antique').val();
      this.$UserService.updateDetails(this.detailsData).then((result) => {
        this.$UserService.updateEmployement(this.employmentData).then((result) => {
          this.$UserService.updateUser(this.userData).then((result) => {
            this.currentStep = 2;
            this.getStates();
            this.preloaderHiden();
          }, (err) => { console.log(err); alert('Se requiere completar los campos requeridos de usuario'); this.preloaderHiden(); });
        }, (err) => { alert('Se requiere completar los campos requeridos de empleo'); this.preloaderHiden(); });
      }, (err) => { alert('Se requiere completar los campos requeridos de detalle'); this.preloaderHiden(); });
    },
    saveStepTwo() {
      this.preloader();
      this.userData.data.a_step = 3;
      this.addressData.data.current_living = $('#current-living').val();
      this.addressData.data.living_since = $('#living-since').val();
      this.$UserService.updateAddress(this.addressData).then((result) => {
        this.$UserService.updateUser(this.userData).then((result) => {
          this.currentStep = 3;
          this.preloaderHiden();
        }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    saveStepThree() {
      this.preloader();
      this.userData.data.a_step = 4;
      const confirType = {
        type: parseInt($('#confirmation-type').val())
      };

      this.$UserService.sendConfirmationCode(confirType).then((result) => {
        this.$UserService.updateUser(this.userData).then((result) => {
          this.currentStep = 4;
          this.preloaderHiden();
        }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    saveStepFour() {
      this.preloader();
      this.userData.data.a_step = 5;
      this.$UserService.updateCreditQuotation(this.quote_credit)
        .then(result => { },
          err => {
            this.$swal("CUIDADO!", err.msg, "error");
            this.preloaderHiden();
          });

      if (this.confirmations.length == 2) {
        this.$UserService.validarCodigoBuro(this.confirmationData).then((result) => {
          this.$UserService.bureauConsult().then((result) => {
            if (result.status == 1 && result.data.approved == 1) {
              this.$UserService.updateUser(this.userData)
                .then((result) => {
                  // let data = {
                  //   message:  `¡Hola, *${this.detailsData.data.first_name} ${this.detailsData.data.father_name}*! \n`+
                  //   "Te confirmamos que hemos recibido tu solicitud exitosamente; te acompañaremos en todo momento de tu proceso.",
                  //   number: `521${this.userData.data.phone}`
                  // };
                  //this.$SendWhatsappService.sendWhatsapp(data).then((result) => {
                  this.$UserService.verifyConfirmationCode(this.confirmationData).then((result) => {
                    this.currentStep = 5;
                    this.preloaderHiden();
                    // }, (err) => {this.$swal("CUIDADO!",err.msg,'error');this.preloaderHiden();});
                  }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); })
                    .finally(function () {
                      localStorage.removeItem('quote_credit');
                      //window.location = '/';
                    });
                });
            } else {
              this.userData.data.a_step = -1;
              this.$UserService.updateUser(this.userData)
                .then((result) => {
                  this.$UserService.verifyConfirmationCode(this.confirmationData)
                    .then((result) => {
                      this.currentStep = -1;
                      this.preloaderHiden();
                    }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
                }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); })
                .finally(function () {
                  this.preloaderHiden();
                  //this.$swal('CUIDADO!','Favor de intentar de nuevo en 6 meses','warning');
                  this.currentStep = -1;
                  //window.location = '/';
                });
            }
          }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
        }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
      } else {
        this.preloaderHiden();
        this.$swal('CUIDADO!'
          , 'Por favor confirme que su información es verídica y autoriza a Credimóvil para la obtención de su historial crediticio y que está de acuerdo con que Credimóvil lleve a cabo investigaciones sobre mi historial crediticio'
          , 'warning');
      }
    },
    saveStepSix() {
      this.preloader();
      this.userData.data.a_step = 7;
      this.$UserService.updateUser(this.userData)
        .then((result) => {

          this.referenceData.data1.type = $('#type_reference1').val();
          this.referenceData.data2.type = $('#type_reference2').val();
          this.referenceData.data.type = $('#type_reference').val();

          this.$UserService.updateReference({ data: this.referenceData.data1 }).then((result) => {
            this.$UserService.updateReference({ data: this.referenceData.data2 }).then((result) => {
              this.$UserService.updateReference({ data: this.referenceData.data }).then((result) => {
                this.currentStep = 7;
                this.preloaderHiden();
              }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
            }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
          }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
        }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    helpDesck: function () {
      const inputOptions = new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            '': 'Seleccione un horario',
            'De 9:00 AM a 11:59 AM': 'De 9:00 AM a 11:59 AM',
            'De 12:00 AM a 02:00 PM': 'De 12:00 AM a 02:00 PM',
            'De 03:30 PM a 06:00 PM': 'De 03:30 PM a 06:00 PM'
          })
        }, 500)
      });

      this.$swal.fire({
        title: '¿En qué horario podemos contactarnos con usted?',
        imageUrl: '../../images/logo-splash-negro1.jpeg',
        input: 'select',
        inputOptions: inputOptions,
        backdrop: `
            rgba(0,0,123,0.4)
            url("../../images/logo-splash.png")
            left top
            no-repeat
          `,
        inputValidator: (value) => {
          if (!value) {
            return 'Nécesita seleccionar un horario de contacto'
          } else {
            var html = `<h3>${this.userData.data.name} Nécesita de tu ayuda</h3>` +
              `El cliente termino su solicitud con éxito y requiere de tu apoyo con el formulario de ` +
              `<b>Cónoce a tu cliente.</b>` +
              `<br><br><b>Sigue los siguientes pasos:</b>` +
              `<br>&emsp;&emsp;<b>1. </b>El cliente solicita contactarlo <b>${value}</b>` +
              `<br>&emsp;&emsp;<b>2. </b>Entra a su cuenta` +
              `<br>&emsp;&emsp;<b>3. </b>Da clic en el botón <b>acelerar</b>` +
              `<br>&emsp;&emsp;<b>4. </b>Junto con el cliente llena el formulario faltante` +
              `<br><br> Ingresa a <b>www.gpiautocomercial.com</b> con el correo <b>${this.userData.data.email}</b> y como contraseña ponga su clave de asesor` +
              ``;
            var subject = 'Crédimovil - Un cliente necesita de tu ayuda!';
            this.$UtilityService.sendEmail(html, subject);
            this.$swal("¡Gracias!", "Un asesor se pondra un cóntacto <br><b>" + value + "</b>", 'success');
          }
        }
      });
    },
    formGrayZone() {
      this.userData.data.a_step = 6;
      this.$UserService.updateUser(this.userData)
        .then((result) => {
          window.location = '/gray-zone';
        }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });

    },
    getUser() {
      this.$UserService.getUser().then((result) => {
        if (result.data.length > 0) {
          this.clickupTaskId = result.data[0].clickup_task;
          this.userData.data.id = localStorage.getItem("id");
          this.quote_credit.data.user_id = localStorage.getItem("id");
          this.userData.data.name = result.data[0].name;
          this.userData.data.email = result.data[0].email;
          this.userData.data.phone = String(result.data[0].phone);
          this.userData.data.phone_code = result.data[0].phone_code;
          this.userData.data.a_step = result.data[0].a_step;
          this.userData.data.clave_asesor = result.data[0].clave_asesor;
          this.currentStep = this.userData.data.a_step;
          if (this.userData.data.a_step > 5 && this.userData.data.a_step < 10) {
            window.location = '/gray-zone';
          }
          //console.log(this.userData.data);
          this.getStates();
        }
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    getDetails() {
      this.$UserService.getDetails().then((result) => {
        if (result.data.length > 0) {
          this.detailsData.data.first_name = result.data[0].first_name;
          this.detailsData.data.last_name = result.data[0].last_name;
          this.detailsData.data.father_name = result.data[0].father_name;
          this.detailsData.data.mother_name = result.data[0].mother_name;
          this.detailsData.data.DOB = moment(result.data[0].DOB, 'YYYY-MM-DD').format('DD-MM-YYYY');
          this.detailsData.data.gender = result.data[0].gender;
          this.detailsData.data.RFC = result.data[0].RFC;
          this.detailsData.data.CURP = result.data[0].CURP;
          this.detailsData.data.state_dob = result.data[0].state_dob;
          this.detailsData.data.marital_status = result.data[0].marital_status;
          this.detailsData.data.antique = result.data[0].antique;
          this.detailsData.data.economic_dependents = result.data[0].economic_dependents;
          setTimeout(() => {
            $('#genero').val(this.detailsData.data.gender);
            $('#birth-date').val(this.detailsData.data.DOB);
            $('#estado-civil').val(this.detailsData.data.marital_status);
            $('#antique').val(this.detailsData.data.antique);
            $('#genero').niceSelect('update');
            $('#birth-date').niceSelect('update');
            $('#estado-civil').niceSelect('update');
            $('#antique').niceSelect('update');
          }, 300);
        }
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    getDocuments() {
      this.$UserService.getDocuments().then((result) => {
        if (result.data.length > 0) {
          this.documents.data.clickup_task = this.clickupTaskId
          this.documents.data.ine = result.data[0].ine;
          this.documents.data.ingreso = result.data[0].ingreso;
          this.documents.data.domicilio = result.data[0].domicilio;

        }
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    getEmployement() {
      this.$UserService.getEmployement().then((result) => {
        if (result.data.length > 0) {
          this.employmentData.data.default_ocupation = result.data[0].default_ocupation;
          this.defaultOcupation = (this.employmentData.data.default_ocupation ? 'yes' : 'no');

          setTimeout(() => {
            ;
            $('#employment-situation').val(this.employmentData.data.employment_situation);
            $('#employment-situation').niceSelect('update');
          }, 300);
        }
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    getAddress() {
      this.$UserService.getAddress().then((result) => {
        if (result.data.length > 0) {
          this.addressData.data.street = result.data[0].street;
          this.addressData.data.address_no = result.data[0].address_no;
          this.addressData.data.address_inside_no = result.data[0].address_inside_no;
          this.addressData.data.state = result.data[0].state;
          this.addressData.data.town = result.data[0].town;
          this.addressData.data.suburb = result.data[0].suburb;
          this.addressData.data.postcode = result.data[0].postcode;
          this.addressData.data.living_since = result.data[0].living_since;
          this.addressData.data.current_living = result.data[0].current_living;
          this.addressData.data.living_since = result.data[0].living_since;

          setTimeout(() => {
            $('#current-living').val(this.addressData.data.current_living);
            $('#living-since').val(this.addressData.data.living_since);
            $('#current-living').niceSelect('update');
            $('#living-since').niceSelect('update');
          }, 300);
          if (this.addressData.data.state) {
            this.getTownships();
            setTimeout(() => {
              this.getSuburb();
            }, 300);
          }
        }
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    getReference() {
      this.$UserService.getReference().then((result) => {
        if (result.data.length > 0) {
          this.referenceData.data1.name = result.data[0].name;
          this.referenceData.data1.phone = result.data[0].phone;
          this.referenceData.data1.type = result.data[0].type;
        }
        if (result.data.length >= 2) {
          this.referenceData.data2.name = result.data[1].name;
          this.referenceData.data2.phone = result.data[1].phone;
          this.referenceData.data2.type = result.data[1].type;
        }
        if (result.data.length >= 3) {
          this.referenceData.data.name = result.data[2].name;
          this.referenceData.data.phone = result.data[2].phone;
          this.referenceData.data.type = result.data[2].type;
        }
        setTimeout(() => {
          ;
          $('#type_reference1').val(this.referenceData.data1.type);
          $('#type_reference1').niceSelect('update');
          $('#type_reference2').val(this.referenceData.data2.type);
          $('#type_reference2').niceSelect('update');
          $('#type_reference').val(this.referenceData.data.type);
          $('#type_reference').niceSelect('update');
        }, 300);
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    selectDate() {
      $('#birth-date').datepicker('show');
    },
    continueRequest(type) {
      this.preloader();
      this.$UserService.getDetails().then((result) => {
        if (result.data.length > 0) {
          var data = {
            data: {
              clickupTaskId: this.clickupTaskId,
              bc_score: result.data[0].bc_score + "",
              request_type: type
            }
          };
          //if (data.data.bc_score) {
          this.$UserService.getUser().then((resultUser) => {
            if (result.data.length > 0) {
              data.data.clickupTaskId = resultUser.data[0].clickup_task;
              this.$UserService.requestType(data).then((res) => {
                if (type == "online") {
                  this.userData.data.a_step = 6;
                  this.currentStep = 6;
                } else if (type == "whatsapp") {
                  let data = {
                    message: `¡Hola, *${this.detailsData.data.first_name} ${this.detailsData.data.father_name}*! \n` +
                      "Para agilizar tu tramite sube la siguiente *documentación* y espera a que nuestros asesores validen tus datos para continuar con tu solicitud. \n" +
                      "*1. Identificación oficial*\n" +
                      "*2. Comprobante de domicilio*\n" +
                      "*3. Comprobante de ingresos*",
                    number: `521${this.userData.data.phone}`
                  };
                  this.$SendWhatsappService.sendWhatsapp(data);
                  this.userData.data.a_step = 7;
                  this.currentStep = 7;
                }
                this.$UserService.updateUser(this.userData)
                  .then((result) => {
                    this.preloaderHiden();
                  }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
              }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
            }
          }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
          //}
        }
      });
    },
    onPickFile(name) {
      switch (name) {
        case 'ine':
          this.$refs.fileInputINE.click();
          break;
        case 'fill_ine':
          this.$refs.fileInputFillIne.click();
          break;
        case 'domicilio':
          this.$refs.fileInputDomicilio.click();
          break;
        case 'ingreso':
          this.$refs.fileInputIngreso.click();
          break;
        default:
          this.$swal("CUIDADO!", 'onPickFile no cuenta con esta opcion:' + name, 'error');
      }
    },
    onFilePicked(event, filename) {
      this.preloader();
      var target = event.target;
      var parent = target.parentElement;
      var data = {
        data: {
          clickupTaskId: this.clickupTaskId,
          files: { file: event.target.files[0], name: filename }
        }
      };
      this.$UserService.getUser().then((resultUser) => {
        data.data.clickupTaskId = resultUser.data[0].clickup_task;
        this.$UserService.uploapFileToClickUp(data).then((result) => {
          //parent.classList.add('successful');
          //console.log("--------------------",result);
          if (result.data.status == 0) {
            parent.classList.add('error');
            this.$swal("CUIDADO!", result.data.msg, 'error');
            this.preloaderHiden();
          } else {
            this.documents.data[filename] = 'true';
            this.$swal("Documento envíado", "Sí tienes mas archivos por enviar, repite el proceso.", 'success');
            this.preloaderHiden();
          }
        }, (err) => {
          parent.classList.add('error');
          this.$swal("CUIDADO!", "Tenemos un problema para subir su archivo " + err.msg, 'error');
          this.preloaderHiden();
        });
      }, (err) => { this.$swal("CUIDADO!", "getUser " + err.msg, 'error'); this.preloaderHiden(); });
    },
    onGetFillIne(event, filename) {
      this.preloader();
      var target = event.target;
      var parent = target.parentElement;
      var data = {
        data: {
          files: { file: event.target.files[0], name: filename }
        }
      };
      this.$UserService.uploapFileToFillIne(data).then((result) => {
        //console.log("--------------------",result);
        if (result.data.status == 0) {
          parent.classList.add('error');
          this.$swal("CUIDADO!", result.data.msg, 'error');
          this.preloaderHiden();
        } else {
          this.fillDataIne(result.data);
          this.documents.data[filename] = 'true';
          this.preloaderHiden();
        }
      }, (err) => {
        parent.classList.add('error');
        this.$swal("CUIDADO!", "Tenemos un problema para subir su archivo " + err.msg, 'error');
        this.preloaderHiden();
      });
    },
    fillDataIne(data) {
      this.detailsData.data.first_name = data.name.nombre;
      this.detailsData.data.last_name = data.name.segundo_nombre;
      this.detailsData.data.father_name = data.name.apellido_paterno;
      this.detailsData.data.mother_name = data.name.apellido_materno;
      this.detailsData.data.DOB = moment(data.dob, 'DD/MM/YYYY').format('DD-MM-YYYY');
      this.detailsData.data.gender = data.gender == "H" ? "MASCULINO" : "FEMENINO";
      this.detailsData.data.CURP = data.CURP;
      this.detailsData.data.state_dob = Object.keys(statesKey).find(key => statesKey[key] === data.CURP.substring(11, 13));

      setTimeout(() => {
        $('#genero').val(this.detailsData.data.gender);
        $('#birth-date').val(this.detailsData.data.DOB);
        $('#state_dob').val(this.detailsData.data.state_dob);
        $('#genero').niceSelect('update');
        $('#birth-date').niceSelect('update');
        $('#state_dob').niceSelect('update');
        $('#name').prop("disabled", true);
        $('#second-name').prop("disabled", true);
        $('#apellido').prop("disabled", true);
        $('#apellido-m').prop("disabled", true);
        $('#birth-date').prop("disabled", true);
        $('#genero').prop("disabled", true);
        $('#birth-date').prop("disabled", true);
        $('#state_dob').prop("disabled", true);

        this.refreshSelects();
        this.onChangeStateDob();
      }, 300);
    },
    modalTyC() {
      this.$swal("Importante!", "Autorizo expresamente a Gpi Auto comercial SAPI de CV, para lleve a cabo Investigaciones sobre mi comportamiento Crediticio en las Sociedades de Información Crediticia (SIC) que estime conveniente. Conozco la naturaleza y alcance de la información que se solicitará, del uso se le dará y que se podrán realizar consultas periódicas de mi historial crediticio. Consiento que esta autorización tenga una vigencia de 3 años contados a partir de hoy, y en su caso mientras mantengamos relación jurídica. Acepto que este documento quede bajo propiedad de Gpi Auto comercial SAPI de CV para efectos de control y cumplimiento del artículo 28 de la LRSIC", 'info');
    },
    preloader() {
      $('.preloader').fadeIn();
      $('.preloader').delay(10).fadeIn('slow');
    },
    preloaderHiden() {
      $('.preloader').fadeOut();
      $('.preloader').delay(10).fadeOut('slow');
    }
  },
  created() {
    this.getLote();
    this.getQuoteCredit();
    this.getUser();
    this.getDetails();
    this.getEmployement();
    this.getAddress();
    this.getStates();
    this.getDocuments();
    this.getReference();
    localStorage.removeItem('quote_credit');
  },

}


</script>

<style lang="scss">
.error {
  border-color: red;
}

.bg-banner {
  background-color: rgb(39, 89, 171);
}

.nice-select .current {
  width: -webkit-fill-available !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.tittleH2 {
  font: 700 40px/50px "Nunito", sans-serif;
  color: #f59019;
  position: relative;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/PreApproval.vue